export const pains = [
  {
    emoji: '🧪',
    title: 'Your expired medications are still in the cabinet.',
    body: 'The average American home has at least 5 expired medications stored alongside active ones. In the dark. Unlabeled. Indistinguishable. One mistake away from being taken by the wrong person.',
  },
  {
    emoji: '🌡️',
    title: 'Your bathroom is chemically destroying your prescriptions.',
    body: 'Heat and humidity from your daily shower degrade active ingredients silently. The pill looks identical. The box says it’s fine. But the chemistry is gone — and your treatment is failing without a single visible sign.',
  },
  {
    emoji: '⚠️',
    title: 'Your “natural” supplement may be making your prescription dangerous.',
    body: 'Over 50% of American adults combine herbal supplements with prescription medications. Most never tell their doctor. Some combinations cause internal bleeding, organ failure, or complete treatment failure — and they feel completely normal until they don’t.',
  },
  {
    emoji: '🚨',
    title: 'If there was an emergency tonight — you wouldn’t be ready.',
    body: 'No organized cabinet. No medication list. No way to tell a paramedic what your father takes, what your child is allergic to, or where the EpiPen is. This is the moment every disorganized home pharmacy fails — and it only takes once.',
  },
]

export const tomes = [
  {
    number: '01',
    title: 'The Visual Code & Blister Semiotics',
    subtitle: 'The Professional Home Guide to Medication Identification',
    image:
      'https://cdn.magicpatterns.com/uploads/qMG1Kh6LZsXwyw2WXGLGV2/ChatGPT_Image_30_jul_2026,_09_22_52_p.m..png',
    body: 'Right now, you can’t tell a safe blister pack from a compromised one. You can’t identify which medications are being destroyed by light. You can’t detect micro-damage in foil that allows months of silent degradation. This guide gives you the professional visual inspection system that catches every risk before it reaches your family.',
  },
  {
    number: '02',
    title: 'Pharmaceutical Technology At Home',
    subtitle: 'Understanding How Your Medications Are Made — And Why It Changes Everything',
    image:
      'https://cdn.magicpatterns.com/uploads/1JyEDpF3vKVUkLpVfZzEVx/ChatGPT_Image_30_jul_2026,_09_23_06_p.m..png',
    body: 'Crushing the wrong tablet can turn a 24-hour controlled dose into an immediate overdose. Splitting an enteric-coated pill can destroy its protective mechanism entirely. This guide tells you exactly which medications must never be altered — and what happens when they are.',
  },
  {
    number: '03',
    title: 'The Integrity & Storage Protocol',
    subtitle: 'The Complete Science-Based Guide to Professional Medication Storage at Home',
    image:
      'https://cdn.magicpatterns.com/uploads/otienuJFfQLx2LzBqErioF/ChatGPT_Image_30_jul_2026,_09_23_13_p.m..png',
    body: 'For every 10°C of temperature increase, chemical degradation doubles. Your bathroom cabinet regularly reaches temperatures and humidity levels that reduce medication potency by 30-50% — without any visible sign. This guide shows you exactly where to store every medication in your home to guarantee it works when you need it.',
  },
  {
    number: '04',
    title: 'Professional Med-Cabinet Organization',
    subtitle:
      'The Step-by-Step System for Organizing Your Entire Home Pharmacy by Category, Risk Level, and User',
    image:
      'https://cdn.magicpatterns.com/uploads/dTmtXhuBWNja2cCwN7FkMb/ChatGPT_Image_30_jul_2026,_09_23_26_p.m..png',
    body: 'In a medical emergency, a disorganized cabinet costs critical minutes. An unlabeled medication costs a correct diagnosis. A missing list costs a safe hospital admission. This guide builds the organized, documented, user-segregated home pharmacy that protects your family before, during, and after any medical event.',
  },
  {
    number: '05',
    title: 'Pharma-Botanic & Interaction Safety',
    subtitle:
      'The Essential Guide to Combining Supplements, Herbs, and Natural Remedies With Your Pharmaceuticals',
    image:
      'https://cdn.magicpatterns.com/uploads/pMcateKNUFH9h2hFmRGh9r/ChatGPT_Image_30_jul_2026,_09_23_31_p.m..png',
    body: 'St. John’s Wort makes birth control fail. Ginkgo Biloba combined with blood thinners causes uncontrolled bleeding. Grapefruit juice turns a normal statin dose into a toxic one. These are not rare edge cases — they happen in ordinary homes every day. This guide gives you the complete interaction map for the 15 highest-risk botanicals so none of them happen in yours.',
  },
  {
    number: '06',
    title: 'The Expiry Audit & Eco-Disposal',
    subtitle:
      'The Professional System for Reading Expiration Dates, Understanding Chemical End-of-Life, and Safely Eliminating Pharmaceutical Waste From Your Home',
    image:
      'https://cdn.magicpatterns.com/uploads/peRDTgiRnfnwdwCsGN6RJM/ChatGPT_Image_30_jul_2026,_09_23_38_p.m..png',
    body: 'Expired tetracycline antibiotics cause kidney damage. A degraded EpiPen fails in anaphylaxis. Post-BUD insulin delivers insufficient glucose control — and the patient believes their diabetes is being managed when it is not. This guide tells you exactly which expired medications are dangerous — not just ineffective — and how to audit and dispose of everything safely.',
  },
]

export const insideLook = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/frbkVPuhWbWp3TpC5UTJKH/Captura_de_pantalla_2026-08-04_171853.png',
    caption: 'Tome 1 — Chapter 1: the language of pharmaceutical packaging',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jHsYMQK8Ffoy4UHTkgG3A2/Captura_de_pantalla_2026-08-04_173756.png',
    caption: 'Bonus 3 — Chart 1A: The Grapefruit Danger Zone interaction table',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/dwCGTNTP8fXg9ZBqxt4bAN/Captura_de_pantalla_2026-08-04_174411.png',
    caption: 'Bonus 1 — Section 1 of the printable 10-minute med-audit checklist',
  },
]

export const bonuses = [
  {
    label: 'Bonus 1',
    title: 'The 10-Minute Home Med-Audit',
    subtitle: 'Your Complete Printable Checklist for an Immediate Professional Cabinet Review',
    image:
      'https://cdn.magicpatterns.com/uploads/hPQa5LBz5DQmPFic3NgA3A/ChatGPT_Image_30_jul_2026,_09_23_42_p.m..png',
    body: 'Most people believe their cabinet is fine — until they actually check it. This 10-minute printable checklist gives you the exact protocol to verify every medication in your home right now. Most people find at least 3 items that need immediate action on their first audit. Will yours be different?',
  },
  {
    label: 'Bonus 2',
    title: 'The Physical Med-Tracker',
    subtitle: 'Your Complete Printable Medication Inventory Ledger',
    image:
      'https://cdn.magicpatterns.com/uploads/m9if5wH4PVjnUiZX3gVDWu/ChatGPT_Image_30_jul_2026,_09_23_46_p.m..png',
    body: 'When a paramedic asks what medications your father takes, you need to know in seconds — not minutes. This physical ledger is the documentation system that makes every medical emergency faster, safer, and less dangerous. Print it once. Keep it inside your cabinet. Update it when anything changes. It could be the most important piece of paper in your home.',
  },
  {
    label: 'Bonus 3',
    title: 'The “Kitchen Pharmacy” Safety Chart',
    subtitle: 'Your Complete Printable Food-Drug and Botanical-Drug Interaction Reference',
    image:
      'https://cdn.magicpatterns.com/uploads/kpXYdBujTN21a6UH9KXuot/ChatGPT_Image_30_jul_2026,_09_23_49_p.m..png',
    body: 'Every day, families unknowingly combine foods and supplements that make their prescriptions toxic, ineffective, or dangerous. This kitchen poster gives every person in your household an immediate visual reference — posted where decisions about food and supplements are made. Before the combination happens. Not after.',
  },
]

export const transformations = [
  {
    emoji: '⚡',
    before: 'You hope the medication is still good.',
    after: 'You know it is — because you audited it, stored it correctly, and verified it this quarter.',
  },
  {
    emoji: '🛡️',
    before: 'You assume your supplements are safe to combine.',
    after:
      'You have a complete interaction map that tells you exactly what to avoid — and what your pharmacist confirmed is safe.',
  },
  {
    emoji: '🚨',
    before: 'In an emergency, you search for the EpiPen, the medication list, the prescription details.',
    after:
      'Everything is in Zone 1, clearly labeled, immediately accessible, and known to every adult in the household.',
  },
  {
    emoji: '👴',
    before:
      'Your elderly parent’s caregiver administers medications from a disorganized cabinet with no documentation.',
    after:
      'A complete Medication Administration Record ensures every dose is tracked, every caregiver is aligned, and no medication is ever doubled or missed.',
  },
  {
    emoji: '💊',
    before: 'Your prescription works at 60% potency because it spent six months in a bathroom cabinet.',
    after:
      'Every medication in your home is stored at the exact conditions its manufacturer engineered it for — guaranteed to perform when your family needs it.',
  },
]

export const costComparisons = [
  {
    label: 'One emergency room visit because an interaction wasn’t caught',
    value: '$1,200+',
  },
  {
    label: 'One month of ineffective treatment because a medication was stored incorrectly',
    value: 'Priceless.',
  },
  {
    label: 'One moment of panic because the EpiPen expired last month',
    value: 'Irreversible.',
  },
]

export const testimonials = [
  {
    quote:
      'I had no idea my bathroom cabinet was destroying my medications. After reading Tome 3, I reorganized everything in one afternoon. My insulin is properly stored for the first time in years.',
    initial: 'S',
    name: 'Sandra T.',
    role: 'Caregiver, Texas',
  },
  {
    quote:
      'The supplement interaction guide changed everything for me. I had been combining St. John’s Wort with my antidepressant for months. My doctor never asked. This guide caught it. I can’t recommend it enough.',
    initial: 'J',
    name: 'James R.',
    role: 'Retired, London',
  },
  {
    quote:
      'I used Bonus 2 to create a complete medication record for my mother. Last month she was admitted to the ER and I handed the nurse a complete list in seconds. The doctor said it was the most prepared family he’d seen.',
    initial: 'L',
    name: 'Linda M.',
    role: 'Family Caregiver, Florida',
  },
]

export const faqs = [
  {
    question: 'Is this a physical product or a digital one?',
    answer:
      'The Pharma-Masterclave is a 100% digital product delivered instantly in PDF format. Immediately after your purchase, you receive an email with a link to your private Google Drive folder where all 9 PDF files are available to view and download. You can access them from your phone, tablet, or computer at any time.',
  },
  {
    question: 'Do I need a medical or pharmacy background to use this?',
    answer:
      'Absolutely not. This system was specifically designed for families with no medical background. Every technical concept is translated into clear, practical, plain-language guidance that any adult can understand and apply the same day they read it.',
  },
  {
    question: 'Is this relevant for both the US and the UK?',
    answer:
      'Yes. The system references both FDA (USA) and MHRA (UK) guidelines throughout. All disposal programs, recall alert systems, storage standards, and legal frameworks are provided for both countries.',
  },
  {
    question: 'Are the 3 bonuses included in the $27?',
    answer:
      'Yes. All 3 action tools — The 10-Minute Home Med-Audit Checklist, The Physical Med-Tracker Ledger, and The Kitchen Pharmacy Safety Chart — are included completely free with your $27 purchase today. No upsells required.',
  },
  {
    question: 'Can I print the materials?',
    answer:
      'Yes — and it’s strongly encouraged. The three bonuses are specifically designed to be printed and used physically. The checklist to complete by hand during your cabinet audit. The ledger to keep permanently inside your cabinet. The safety chart to post in your kitchen where food and supplement decisions are made daily.',
  },
  {
    question: 'What if I already think my cabinet is organized?',
    answer:
      'Most people who go through Tome 1 and the 10-Minute Audit Checklist in Bonus 1 discover at least 3 issues they didn’t know existed — expired medications, incorrect storage locations, or supplement combinations they weren’t aware of. The system is designed to reveal what you don’t know you don’t know.',
  },
]

export const systemMockupUrl =
  'https://cdn.magicpatterns.com/uploads/rnTz9aUeXiHmofcMfUp7Fv/ChatGPT_Image_3_ago_2026,_07_34_52_p.m..png'

export const guidesMockupUrl =
  'https://cdn.magicpatterns.com/uploads/28MnfwXXn7qsstqkvomT8g/ChatGPT_Image_3_ago_2026,_07_43_09_p.m..png'
